(() => {
  const HEADER_SELECTOR = '.agni-compact-header--transparent';

  const ANNOUNCEMENT_SELECTOR = [
    '[data-agni-announcement-bar]',
    '.agni-revolving-bar',
    '.agni-offers-bar',
    '.announcement-bar-section .utility-bar',
    '.announcement-bar-section .announcement-bar',
  ].join(',');

  let resizeObserver;
  let observedAnnouncement;
  let animationFrame;

  const elementsBefore = (element, reference) =>
    Boolean(
      element.compareDocumentPosition(reference) &
        Node.DOCUMENT_POSITION_FOLLOWING
    );

  const updateHeaderOffset = () => {
    const header = document.querySelector(HEADER_SELECTOR);

    if (!header) return;

    /*
     * At the top of the homepage, is-scrolled is absent and the header
     * remains transparent. After scrolling more than 12 pixels,
     * is-scrolled is added and the header uses its configured solid
     * background.
     */
    header.classList.toggle(
      'is-scrolled',
      window.scrollY > 12
    );

    const headerSection =
      header.closest('.shopify-section') ||
      header.parentElement;

    const announcement = Array.from(
      document.querySelectorAll(ANNOUNCEMENT_SELECTOR)
    ).find(
      (element) =>
        elementsBefore(element, header) &&
        element.getClientRects().length > 0
    );

    /*
     * Preserve the existing announcement-bar offset behaviour that
     * removed the gap and overlap.
     */
    const announcementBottom = announcement
      ? Math.max(
          0,
          Math.min(
            window.innerHeight,
            announcement.getBoundingClientRect().bottom
          )
        )
      : 0;

    document.documentElement.style.setProperty(
      '--agni-announcement-bar-height',
      `${announcementBottom}px`
    );

    headerSection.style.top = `${announcementBottom}px`;

    if (
      announcement !== observedAnnouncement &&
      'ResizeObserver' in window
    ) {
      resizeObserver?.disconnect();

      resizeObserver = new ResizeObserver(
        updateHeaderOffset
      );

      if (announcement) {
        resizeObserver.observe(announcement);
      }

      observedAnnouncement = announcement;
    }
  };

  const scheduleUpdate = () => {
    if (animationFrame) return;

    animationFrame = requestAnimationFrame(() => {
      animationFrame = null;
      updateHeaderOffset();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateHeaderOffset,
      { once: true }
    );
  } else {
    updateHeaderOffset();
  }

  window.addEventListener(
    'load',
    updateHeaderOffset,
    { once: true }
  );

  window.addEventListener(
    'resize',
    scheduleUpdate,
    { passive: true }
  );

  window.addEventListener(
    'scroll',
    scheduleUpdate,
    { passive: true }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );

  document.addEventListener(
    'shopify:section:reorder',
    scheduleUpdate
  );
})();